import React from "react";
import "../index.css";

const StayInformed = () => {
    return (
        <section className="bg-gray-100 w-full py-12 px-4 md:px-12 lg:px-20">
            <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-8">

                {/* Left: Text */}
                <div className="flex flex-col gap-2">
                    <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
                        Stay Informed
                    </h2>
                    <p className="text-gray-400 text-sm tracking-wide">
                        Get direct updates of BCS News
                    </p>
                </div>

                {/* Right: Buttons */}
                <div className="flex items-center gap-3 flex-shrink-0">
                    <button className="flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white text-sm font-semibold px-6 py-3 rounded-full transition-all duration-200">
                        <svg className="w-3.5 h-3.5 fill-white" viewBox="0 0 10 10">
                            <polygon points="3,1 9,5 3,9" />
                        </svg>
                        Watch Live
                    </button>

                    <a href="https://whatsapp.com/channel/0029Va5U9BCDp2Q76KgBTK2W" target="_blank" rel="noreferrer" className="flex items-center gap-2 border border-red-500 text-red-500 hover:bg-red-50 text-sm font-semibold px-6 py-3 rounded-full transition-all duration-200">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M10.172 13.828a4 4 0 015.656 0l4-4a4 4 0 01-5.656-5.656L12.07 5.07" />
                        </svg>
                        Join Channel
                    </a>
                </div>

            </div>
        </section>
    );
};

export default StayInformed;